/**
 * Sicherer Download von Blob-Dateien im Browser.
 *
 * Warum dieser zentrale Baustein nötig ist:
 * 1. Chromium (Chrome/Edge) und Safari brechen den Download ab oder melden "Netzwerkfehler",
 *    wenn `URL.revokeObjectURL(url)` im selben synchronen Aufruf wie `a.click()` ausgeführt wird,
 *    da der interne Download-Manager den Stream noch nicht gelesen hat.
 * 2. Firefox ignoriert den Klick auf nicht am DOM angehängte `<a>`-Elemente (`document.body.appendChild`).
 * 3. Das Aufräumen (DOM-Remove und Revoke) erfolgt verzögert per setTimeout.
 */

export function triggerBlobDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  try {
    a.click();
  } finally {
    setTimeout(() => {
      a.remove();
      URL.revokeObjectURL(url);
    }, 1000);
  }
}
